/**
 * @generated SignedSource<<b48738aa700325c156d21e01fc503846>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
export type IssueFieldDataType = "DATE" | "MULTI_SELECT" | "NUMBER" | "SINGLE_SELECT" | "TEXT" | "%future added value";
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useHandleTemplateChange$data = {
  readonly issueForm: {
    readonly __typename: "IssueForm";
    readonly assignees: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename?: "User";
          readonly avatarUrl?: string;
          readonly id?: string;
          readonly login?: string;
          readonly name?: string | null | undefined;
          readonly profileResourcePath?: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    };
    readonly elements: ReadonlyArray<{
      readonly __typename: "IssueFormElementCheckboxes";
      readonly checkboxOptions: ReadonlyArray<{
        readonly label: string;
        readonly labelHTML: string;
        readonly required: boolean | null | undefined;
      }>;
      readonly descriptionHTML: string | null | undefined;
      readonly itemId: string | null | undefined;
      readonly label: string;
    } | {
      readonly __typename: "IssueFormElementDropdown";
      readonly defaultOptionIndex: number | null | undefined;
      readonly descriptionHTML: string | null | undefined;
      readonly itemId: string | null | undefined;
      readonly label: string;
      readonly multiple: boolean | null | undefined;
      readonly options: ReadonlyArray<string>;
      readonly required: boolean | null | undefined;
    } | {
      readonly __typename: "IssueFormElementInput";
      readonly descriptionHTML: string | null | undefined;
      readonly itemId: string | null | undefined;
      readonly label: string;
      readonly placeholder: string | null | undefined;
      readonly required: boolean | null | undefined;
      readonly value: string | null | undefined;
    } | {
      readonly __typename: "IssueFormElementMarkdown";
      readonly contentHTML: string;
    } | {
      readonly __typename: "IssueFormElementTextarea";
      readonly descriptionHTML: string | null | undefined;
      readonly itemId: string | null | undefined;
      readonly label: string;
      readonly placeholder: string | null | undefined;
      readonly render: string | null | undefined;
      readonly required: boolean | null | undefined;
      readonly value: string | null | undefined;
    } | {
      readonly __typename: "IssueFormElementUpload";
      readonly accept: string | null | undefined;
      readonly descriptionHTML: string | null | undefined;
      readonly itemId: string | null | undefined;
      readonly label: string;
      readonly required: boolean | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }>;
    readonly filename: string;
    readonly labels: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly color: string;
          readonly description: string | null | undefined;
          readonly id: string;
          readonly name: string;
          readonly nameHTML: string;
          readonly url: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly name: string;
    readonly projects: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "ProjectV2";
          readonly closed: boolean;
          readonly hasReachedItemsLimit: boolean;
          readonly id: string;
          readonly number: number;
          readonly title: string;
          readonly url: string;
          readonly viewerCanUpdate: boolean;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    };
    readonly title: string | null | undefined;
    readonly type: {
      readonly color: IssueTypeColor;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly isEnabled: boolean;
      readonly name: string;
      readonly pinnedFields: ReadonlyArray<{
        readonly __typename: "IssueFieldDate";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldMultiSelect";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldNumber";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldSingleSelect";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldText";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly issueTemplate: {
    readonly __typename: "IssueTemplate";
    readonly assignees: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename?: "User";
          readonly avatarUrl?: string;
          readonly id?: string;
          readonly login?: string;
          readonly name?: string | null | undefined;
          readonly profileResourcePath?: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    };
    readonly body: string | null | undefined;
    readonly filename: string;
    readonly labels: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly color: string;
          readonly description: string | null | undefined;
          readonly id: string;
          readonly name: string;
          readonly nameHTML: string;
          readonly url: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly name: string;
    readonly title: string | null | undefined;
    readonly type: {
      readonly color: IssueTypeColor;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly isEnabled: boolean;
      readonly name: string;
      readonly pinnedFields: ReadonlyArray<{
        readonly __typename: "IssueFieldDate";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldMultiSelect";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldNumber";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldSingleSelect";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldText";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useHandleTemplateChange";
};
export type useHandleTemplateChange$key = {
  readonly " $data"?: useHandleTemplateChange$data;
  readonly " $fragmentSpreads": FragmentRefs<"useHandleTemplateChange">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useHandleTemplateChange"
};

(node as any).hash = "972aaa9608c77d279df72184ec2602c3";

export default node;
